import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getUserFamilyDonations } from "../../service/UserApi";

const DonationDetails = () => {
  const user = useSelector((state) => state.user);
  const [donations, setDonations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDonations = async () => {
      if (!user.email) return;
      setLoading(true);

      try {
        const response = await getUserFamilyDonations(user.email);
        setDonations(response?.donations || []);
      } catch (error) {
        console.error("Error fetching donations:", error);
        setDonations([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDonations();
  }, [user.email]);

  // ✅ Simple local spinner
  const Spinner = () => (
    <div style={{ textAlign: "center", padding: "20px", fontSize: "18px" }}>
      🔄 தரவு ஏற்றப்படுகிறது...
    </div>
  );

  if (loading) return <Spinner />;
  if (!donations.length) return <p>நன்கொடை விவரங்கள் இல்லை</p>;

  const sortedDonations = [...donations].sort((a, b) => {
    const dateA = new Date(a.transactionDate._seconds * 1000);
    const dateB = new Date(b.transactionDate._seconds * 1000);

    if (dateA < dateB) return 1;
    if (dateA > dateB) return -1;

    if (a.category.toLowerCase() < b.category.toLowerCase()) return -1;
    if (a.category.toLowerCase() > b.category.toLowerCase()) return 1;

    if (a.subcategory.toLowerCase() < b.subcategory.toLowerCase()) return 1;
    if (a.subcategory.toLowerCase() > b.subcategory.toLowerCase()) return -1;

    return 0;
  });

  return (
    <>
      <br />
      <h4>நன்கொடை விவரங்கள்</h4>
      <br />
      <ul>
        {sortedDonations.map((d, i) => {
          const date = new Date(d.transactionDate._seconds * 1000).toLocaleDateString("ta-IN", {
            year: "numeric",
            month: "long",
            day: "numeric"
          });

          return (
            <li key={i}>
              {date} அன்று {d.category} {d.subcategory} செலுத்தியவர் {d.familyMemberFirstName}
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default DonationDetails;
